import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";
import GetAllAccountDeletionRequests from "./GetAllAccountDeletionRequests";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

const AccountDeletionRequests = () => {
    const isLogged = Boolean(localStorage.getItem("isLogged"));

    if (!isLogged) {
        return <Navigate to={"/admin/auth/login"} replace={true} />;
    }

    return (
        <div>
            <PageTitle title="Account Deletion Requests" />

            <UserPrivateComponent permission={"readAll-user"}>
                <GetAllAccountDeletionRequests />
            </UserPrivateComponent>
        </div>
    );
};

export default AccountDeletionRequests;